<template>
  <div class="row">
    <div class="col-xl-12 col-lg-12">
      <div>
        <div class="card">
          <div class="card-body">
            <a-table
              :columns="columns"
              :dataSource="filteredData"
              :pagination="true"
              class="table"
              rowKey="id"
              :loading="isLoading"
            >
              <template slot="text" slot-scope="text">
                {{ formatValue(text) }}
              </template>
              <template slot="himponiDate" slot-scope="text">
                {{ formatDate(text) }}
              </template>
              <template slot="createdAt" slot-scope="text">
                {{ formatDate(text) }}
              </template>
              <template slot="programType" slot-scope="programType">
                {{ formatValue(programType) }}
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getHimponiPatients } from '@/services/axios/api/pasien'

export default {
  data() {
    return {
      columns: [
        {
          title: 'Pasien',
          dataIndex: 'code',
          key: 'code',
          scopedSlots: { customRender: 'text' },
        },
        {
          title: 'Program',
          dataIndex: 'programType',
          key: 'programType',
          scopedSlots: { customRender: 'programType' },
        },
        {
          title: 'Tanggal Daftar',
          dataIndex: 'createdAt',
          key: 'createdAt',
          scopedSlots: { customRender: 'createdAt' },
        },
        {
          title: 'Tanggal Interview',
          key: 'himponiDate',
          dataIndex: 'himponiDate',
          scopedSlots: { customRender: 'himponiDate' },
        },
        {
          title: 'Kota',
          dataIndex: 'city',
          key: 'city',
          scopedSlots: { customRender: 'text' },
        },
      ],
      filteredData: [],
      isLoading: false,
      isAdmin: false,
    }
  },
  created() {
    this.getRole()
    this.getHimponiPatients()
  },
  methods: {
    getRole() {
      const date = moment().add(8, 'days')
      console.log(date.toISOString())
      const role = window.localStorage.getItem('role')
      if (role === 'admin' || role === 'apl') {
        this.isAdmin = true
      }
    },
    formatDate(value) {
      if (!value) return '-'
      return moment(value).locale('id').format('DD MMMM YYYY HH:mm:ss')
    },
    formatValue(value) {
      if (value === null || value === undefined || value === '') return '-'
      return value
    },
    async getHimponiPatients() {
      this.isLoading = true
      const res = await getHimponiPatients()
      this.filteredData = res || []
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/components/mixins.scss';

.table {
  white-space: nowrap !important;
  :global(.ant-table-body) {
    overflow-x: auto !important;
  }
}
</style>
